import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ErrorDialogComponent } from "@dialogs/error/error.component";
import { LinkDialogComponent } from "@dialogs/link/link.component";
import { environment } from "@environments/environment";
import { Subject } from 'rxjs';
import {AuthService} from '@services/auth.service';
const invalidColHeaderCharacters = [
  "/",
  "'",
  "#",
  "?",
  ")",
  "(",
  "!",
  "@",
  "#",
  "$",
  "%",
  "^",
  "&",
  "*",
  ".",
  ",",
  ":",
];

@Injectable({
  providedIn: "root",
})
export class CommonService {
  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private dialog: MatDialog
  ) {}

  // Subject to handle numeric field IDs
  private readonly removeFieldSubject = new Subject<number>();

  // Expose the Subject as an Observable
  removeField$ = this.removeFieldSubject.asObservable();

  // Method to trigger the removal of a field with a numeric ID
  triggerRemoveDataField(reportFieldId: number) {
    this.removeFieldSubject.next(reportFieldId);
  }

  public getNavigation(): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/users/current?include=mainMenus&kebab-case-icon-names=true"
    );
  }

    public getAllCategories(): any {
        const refreshToken = this.authService.getSessionRefreshToken();

        return this.http.get(
            environment.enterpriseUrls.apiEndpoint + '/categories?orderBy=name',
            {
                headers: {
                    Authorization: `Bearer ${refreshToken}`,
                }
            }
        );
    }

  public getAllBuilds(): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/cms/builds/products?orderBy=build"
    );
  }

  public refreshBuilds(): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/cms/builds/products/refresh?orderBy=build"
    );
  }

  public toggleBuilds(body: any): any {
    return this.http.post(
      environment.enterpriseUrls.apiEndpoint +
        "/cms/builds/products/deliverable",
      body
    );
  }

  public CMSImportBuilds(body: any): any {
    return this.http.post(
      environment.enterpriseUrls.apiEndpoint +
        "/cms/builds/publish-preview?count=10000",
      body
    );
  }

  public CMSImportBuildsApply(body: any): any {
    return this.http.post(
      environment.enterpriseUrls.apiEndpoint + "/cms/builds/publish",
      body
    );
  }

  public publishFromCMS(body: any): any {
    return this.http.post(
      environment.enterpriseUrls.apiEndpoint + "/cms/builds/publish",
      body
    );
  }

  public getCanvasImports(build: string, categoryId: number) {
    return this.http.post(
      environment.enterpriseUrls.apiEndpoint + '/canvas/imports?count=1000',
      {build, category_id: categoryId}
    );
  }

  public getUserCategories(): any {
    const refreshToken = this.authService.getSessionRefreshToken();

    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        '/users/current/categories?orderBy=name',
      {
        headers: {
          Authorization: `Bearer ${refreshToken}`,
        },
      }
    );
  }

  public getAllSecurityGroups(): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint + "/groups/canvas?count=1000"
    );
  }

  openErrorDialog(type: string, errorMessage: string, detailMessage: string) {
    if (typeof errorMessage == "string") {
      const dialogRef =this.dialog.open(ErrorDialogComponent, {
        panelClass: "modalbox-error",
        data: {
          type: type,
          message: errorMessage,
          detail: detailMessage,
        },
      });

      return dialogRef; // Return the MatDialogRef
    }
    return undefined; // Explicitly return undefined if the condition is false
  }

  openRoadmapLinkDialog(event: any, page: string): void {
    event.stopPropagation();
    const dialogRef = this.dialog.open(LinkDialogComponent, {
      panelClass: "canvas-dialog",
      data: {
        message: "We are consistently adding new features.",
        submessage:
          "To see the project roadmap and upvote existing features or even share new feature ideas, click the button below.",
        buttonText: {
          cancel: "Close",
        },
      },
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        window.open(
          "https://portal.productboard.com/etwqnpybquh7dajblibzdyhs",
          "_blank"
        );
      }
    });
  }

  generateSorts(ID: any, sortFields: any, sortFieldsFromChart: any) {
    let generatedData: any[] = [];
    if (ID) {
      sortFields.controls.forEach((element: any) => {
        if (element.get("field")!.value != null) {
          const data = {
            dataPointId: element.get("field")!.value,
            modifiers: [{ id: ID, value: element.get("sort")!.value }],
          };
          generatedData.push(data);
        }
      });
      if (sortFields.controls.length <= 0) {
        generatedData = [];
      }
    } else {
      sortFieldsFromChart.forEach((sort: any) => {
        const modifications: any[] = [];
        sort.fields.data.forEach((element: any) => {
          modifications.push({ id: element.id, value: element.value });
        });
        const data = {
          dataPointId: sort.dataPoint.data.id,
          modifiers: modifications,
        };
        generatedData.push(data);
      });
    }
    return generatedData;
  }

  filterSorts(sorts: any, datapoints: any) {
    for (var i = sorts.length - 1; i >= 0; i--) {
      if (datapoints.indexOf(sorts[i].fields.data[0].dataPoint.data.id) == -1) {
        sorts.splice(i, 1);
      }
    }
    return sorts;
  }

  filterFilters(filters: any, datapoints: any) {
    for (var i = filters.length - 1; i >= 0; i--) {
      if (datapoints.indexOf(filters[i].dataPoint.data.id) == -1) {
        filters.splice(i, 1);
      }
    }
    return filters;
  }

  generateVisualDataPoints(datapoints: any) {
    let idArray: any[] = [];
    datapoints.forEach((element: any) => {
      if (element.dataPointId) idArray.push(element.dataPointId);
      else idArray.push(element);
    });
    return idArray;
  }

  generateGroups(
    ID: any,
    datefield: any,
    groupFields: any,
    groupFieldsFromChart: any
  ) {
    let generatedData: any[] = [];
    if (groupFields) {
      groupFields.controls.forEach((element: any) => {
        if (element.get("field")!.value != null) {
          let data: any = {};
          if (datefield) {
            data = {
              dataPointId: element.get("field")!.value,
              modifiers: [{ id: ID, value: element.get("range")!.value }],
            };
          } else {
            data = {
              dataPointId: element.get("field")!.value,
              modifiers: [{ id: ID, value: "" }],
            };
          }
          if (data) {
            generatedData.push(data);
          }
        }
      });
      if (groupFields.controls.length <= 0) {
        generatedData = [];
      }
    } else {
      groupFieldsFromChart.forEach((group: any) => {
        const modifications: any[] = [];
        group.fields.data.forEach((element: any) => {
          modifications.push({ id: element.id, value: element.value });
        });
        const data = {
          dataPointId: group.dataPoint.data.id,
          modifiers: modifications,
        };
        generatedData.push(data);
      });
    }

    //generatedData = [];
    return generatedData;
  }

  generateFilters(filterFields: any) {
    let generatedData: any[] = [];
    let condition = "and";

    filterFields.forEach((filter: any, index: any) => {
      let filters;
      let dataPoint;
      if (filter.dataPoint) {
        const modifications: any[] = [];
        filter.fields.data.forEach((element: any) => {
          modifications.push({ id: element.id, value: element.value });
        });
        filters = modifications;
        dataPoint = filter.dataPoint.data.id;
      }
      if (filter.filters) {
        const modifications: any[] = [];
        filter.filters.data.forEach((element: any) => {
          modifications.push({ id: element.id, value: element.value });
        });
        filters = modifications;
        dataPoint = filter.id;
      }

      if (filter.condition) {
        if (index == 0) {
          condition = "na";
        } else {
          condition = filter.condition;
        }
      } else {
        condition = filter.fields.data[0].condition;
      }

      const data = {
        dataPointId: dataPoint,
        condition: condition,
        modifications: filters,
      };
      generatedData.push(data);
    });
    if (generatedData.length > 0) generatedData[0].condition = "na";
    return generatedData;
  }

  generateFormatters(formatFields: any, chart?: any, reportTitle?: string) {
    let generatedData: any[] = [];
    const modifications: any[] = [];
    formatFields.forEach((filter: any) => {
      if (filter.value == true) {
        modifications.push({ id: filter.id, value: true });
      } else {
        if (filter.displayType == "slide-toggle") {
          modifications.push({ id: filter.id, value: false });
        } else {
          modifications.push({ id: filter.id, value: filter.value });
        }
      }
    });
    if (modifications.length <= 0 && chart) {
      let formatterList = chart.formatters.data;
      let selected = formatterList.filter(function (type: any) {
        return type.name == "titleValue";
      });
      modifications.push({ id: selected[0].id, value: reportTitle });
    }
    const data = {
      modifiers: modifications,
    };
    generatedData.push(data);
    return generatedData;
  }

  generateQuantifiers(dataFields: any, id: any, value: any) {
    let generatedData: any[] = [];
    dataFields.forEach((dataPoint: any) => {
      const data = {
        dataPointId: dataPoint.id,
        modifiers: [{ id: id, value: value }],
      };
      generatedData.push(data);
    });
    return generatedData;
  }

  formatSecurityGroups(groups: any, includeName: boolean) {
    let generatedData: any[] = [];
    groups.forEach((group: any) => {
      if (includeName) {
        const data = {
          id: group.id,
          name: group.name,
          edit: group.edit ? 1 : 0,
          view: group.view ? 1 : 0,
        };
        generatedData.push(data);
      } else {
        const data = {
          id: group.id,
          edit: group.edit ? 1 : 0,
          view: group.view ? 1 : 0,
        };
        generatedData.push(data);
      }
    });
    return generatedData;
  }

  getInitials(name: string) {
    let returnVal: string = "";
    let nameArray: any = [];
    if (name) {
      nameArray = name.split(" ");
    }
    if (name && name.includes(",")) {
      returnVal = nameArray[1].charAt(0) + nameArray[0].charAt(0);
    } else {
      for (let i = 0; i < nameArray.length; i++) {
        returnVal += nameArray[i].charAt(0);
      }
    }
    return returnVal;
  }

  sanitizeColumn(col: any) {
    invalidColHeaderCharacters.forEach((character: any) => {
      col = col.replaceAll(character, "-");
    });
    return col;
  }

  /**
   * Generates an HTML list of dashboard names for the given dashboards.
   * 
   * @param dashboards - An array of dashboards, where each dashboard is an object with a `name` property. If `undefined` or empty, no list will be generated.
   * @param title - The title of the dashboard section (e.g., "Legacy Dashboard", "Dashboard Builder") to be included above the list.
   * 
   * @returns A string containing the HTML for the dashboard list. If no dashboards exist, an empty string is returned.
   */
  private generateDashboardList(dashboards: Array<{ name: string }> | undefined, title: string): string {

    if (dashboards && dashboards.length > 0) {
      return `
        <span>${title}</span>
        <ul>
          ${dashboards.map((dashboard: { name: string }) => `<li>${dashboard.name}</li>`).join('')}
        </ul>
      `;
    }

    return '';
  }

  /**
   * Generates a message detailing which dashboards are affected by the deletion of a report.
   * 
   * @param enterpriseDash - Data related to the Enterprise Dashboard (can include `data` with dashboard info or be empty).
   * @param legacyDash - Data related to the Legacy Dashboard (can include `data` with dashboard info or be empty).
   * 
   * @returns A string containing the message about affected dashboards, or an empty string if no dashboards have data.
   */
  generateDashboardMessage(enterpriseDash: any, legacyDash: any): string {
  
    const messageInfo = `<p>The particular report is used on a dashboard, deleting will break a dashboard widget.</p><p>The following dashboard(s) will be affected:</p>`;

    const legacyList = this.generateDashboardList(legacyDash?.data, 'Legacy Dashboard');
    const enterpriseList = this.generateDashboardList(enterpriseDash?.data, 'Dashboard Builder');

    if (legacyList && enterpriseList) {
      return messageInfo + legacyList + enterpriseList;
    }

    if (legacyList) {
      return messageInfo + legacyList;
    }

    if (enterpriseList) {
      return messageInfo + enterpriseList;
    }

    return '';
  }
}
